export default __webpack_public_path__ + "static/media/Beard_10_C1.0ca112eb.svg";